import React from 'react'
import {
  Button,
  Col,
  Container,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
  Row,
} from 'react-bootstrap'
import { Link, NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Flex from '../../components/common/Flex'
import TileLink from '../../components/link/TileLink'

interface Props {
  show: boolean
  handleClose: () => void
  handleShow: () => void
  id: string
}
const TenantEditMenu = ({ show, handleShow, handleClose, id }: Props) => {
  const expand = false
  return (
    <Offcanvas show={show} onHide={handleClose} placement={'end'}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className={'text-primary'}>
          Gérer les ressources
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Container fluid className={'px-0'}>
          <Row className={'mb-3'}>
            <Col md={6} className={''}>
              <TileLink
                icon={'building-user'}
                link={`/tenants/${id}/customers/all`}
                text={'Clients'}
              />
            </Col>
            <Col md={6} className={''}>
              <TileLink
                icon={'box-open'}
                link={`/tenants/${id}/assets/all`}
                text={'Assets'}
              />
            </Col>
          </Row>
          <Row className={'mb-3'}>
            <Col md={6} className={''}>
              <TileLink
                icon={'microchip'}
                link={`/tenants/${id}/devices/all`}
                text={'Devices'}
              />
            </Col>
            <Col md={6} className={''}>
              <TileLink
                icon={'users'}
                link={`/tenants/${id}/users/all`}
                text={'Utilisateurs'}
              />
            </Col>
          </Row>
          <Row className={'mb-3'}>
            <Col md={6} className={''}>
              <TileLink
                icon={'chart-line'}
                link={`/tenants/${id}/dashboards/all`}
                text={'Dashboards'}
              />
            </Col>
            <Col md={6} className={''}>
              <TileLink
                icon={'code-branch'}
                link={`/tenants/${id}/rule-chains`}
                text={'Rule Chains'}
              />
            </Col>
          </Row>
        </Container>
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export default TenantEditMenu
